import React from 'react';

const CustomerStatusBadge = ({ status }) => { 
    const statusStyles = { 
        'New': 'bg-blue-100 text-blue-800', 
        'Contacted': 'bg-yellow-100 text-yellow-800', 
        'Proposal Sent': 'bg-purple-100 text-purple-800', 
        'Closed': 'bg-green-100 text-green-800', 
        'Lost': 'bg-red-100 text-red-800' 
    }; 
    return <span className={`px-2 py-1 inline-flex text-xs leading-5 font-semibold rounded-full ${statusStyles[status] || 'bg-gray-100 text-gray-800'}`}>{status}</span>; 
};

export default CustomerStatusBadge;